import { blockManifestReader } from "eddev/_internal";
import { dynamic } from "eddev/dynamic";
import core from "../../../blocks/_core";
import PartsPartFooter from "../../../blocks/parts/part-footer.tsx";

const manifest = {
  "acf/about-careers-list": dynamic(() =>
    import("../../../blocks/about/careers-list.tsx"), "blocks/about/careers-list.tsx"),
  "acf/about-careers-list-item": dynamic(() =>
    import("../../../blocks/about/careers-list-item.tsx"), "blocks/about/careers-list-item.tsx"),
  "acf/about-team-grid": dynamic(() =>
    import("../../../blocks/about/team-grid.tsx"), "blocks/about/team-grid.tsx"),
  "acf/blog-blog-post-intro": dynamic(() =>
    import("../../../blocks/blog/blog-post-intro.tsx"), "blocks/blog/blog-post-intro.tsx"),
  "acf/case-studies-case-studies-list": dynamic(() =>
    import("../../../blocks/case-studies/case-studies-list.tsx"), "blocks/case-studies/case-studies-list.tsx"),
  "acf/case-study-case-study-intro": dynamic(() =>
    import("../../../blocks/case-study/case-study-intro.tsx"), "blocks/case-study/case-study-intro.tsx"),
  "acf/contact-contact-form": dynamic(() =>
    import("../../../blocks/contact/contact-form.tsx"), "blocks/contact/contact-form.tsx"),
  "acf/content-anchor": dynamic(() =>
    import("../../../blocks/content/anchor.tsx"), "blocks/content/anchor.tsx"),
  "acf/content-case-study-list": dynamic(() =>
    import("../../../blocks/content/case-study-list.tsx"), "blocks/content/case-study-list.tsx"),
  "acf/content-image": dynamic(() =>
    import("../../../blocks/content/image.tsx"), "blocks/content/image.tsx"),
  "acf/content-logo-grid": dynamic(() =>
    import("../../../blocks/content/logo-grid.tsx"), "blocks/content/logo-grid.tsx"),
  "acf/content-page-intro": dynamic(() =>
    import("../../../blocks/content/page-intro.tsx"), "blocks/content/page-intro.tsx"),
  "acf/content-page-section": dynamic(() =>
    import("../../../blocks/content/page-section.tsx"), "blocks/content/page-section.tsx"),
  "acf/content-stat-item": dynamic(() =>
    import("../../../blocks/content/stat-item.tsx"), "blocks/content/stat-item.tsx"),
  "acf/content-stats": dynamic(() =>
    import("../../../blocks/content/stats.tsx"), "blocks/content/stats.tsx"),
  "acf/content-video-embed": dynamic(() =>
    import("../../../blocks/content/video-embed.tsx"), "blocks/content/video-embed.tsx"),
  "acf/parts-part-footer": PartsPartFooter,
  "acf/pillar-pillar-intro": dynamic(() =>
    import("../../../blocks/pillar/pillar-intro.tsx"), "blocks/pillar/pillar-intro.tsx"),
  "acf/services-service-listing": dynamic(() =>
    import("../../../blocks/services/service-listing.tsx"), "blocks/services/service-listing.tsx"),
  ...core,
};

const info = {
  "acf/about-careers-list": { "slug": "about/careers-list", "tags": ["#page"], "flags": {} },
  "acf/about-careers-list-item": { "slug": "about/careers-list-item", "flags": {} },
  "acf/about-team-grid": { "slug": "about/team-grid", "tags": ["#page"], "flags": {} },
  "acf/blog-blog-post-intro": { "slug": "blog/blog-post-intro", "tags": [], "flags": { "selfAnimates": true } },
  "acf/case-studies-case-studies-list": {
    "slug": "case-studies/case-studies-list",
    "tags": ["#page"],
    "flags": { "centered": false },
  },
  "acf/case-study-case-study-intro": {
    "slug": "case-study/case-study-intro",
    "tags": [],
    "flags": { "selfAnimates": true },
  },
  "acf/contact-contact-form": {
    "slug": "contact/contact-form",
    "tags": ["#page"],
    "flags": { "centered": false, "selfAnimates": true },
  },
  "acf/content-anchor": { "slug": "content/anchor", "flags": {} },
  "acf/content-case-study-list": {
    "slug": "content/case-study-list",
    "tags": ["#content"],
    "flags": { "centered": true },
  },
  "acf/content-image": { "slug": "content/image", "tags": ["#page"], "flags": {} },
  "acf/content-logo-grid": { "slug": "content/logo-grid", "tags": ["#page"], "flags": {} },
  "acf/content-page-intro": {
    "slug": "content/page-intro",
    "tags": ["#page"],
    "flags": { "centered": false, "selfAnimates": true },
  },
  "acf/content-page-section": { "slug": "content/page-section", "tags": ["#page"], "flags": {} },
  "acf/content-stat-item": { "slug": "content/stat-item", "flags": {} },
  "acf/content-stats": { "slug": "content/stats", "tags": ["#page"], "flags": {} },
  "acf/content-video-embed": { "slug": "content/video-embed", "tags": ["#content"], "flags": {} },
  "acf/parts-part-footer": { "slug": "parts/part-footer", "flags": {} },
  "acf/pillar-pillar-intro": { "slug": "pillar/pillar-intro", "tags": [], "flags": { "selfAnimates": true } },
  "acf/services-service-listing": { "slug": "services/service-listing", "tags": ["#page"], "flags": {} },
};

blockManifestReader.set(manifest, info);

export default manifest;

if (import.meta.hot) {
  import.meta.hot.accept();
}
